import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonos = [{
  id: 1,
  title: 'Kit Lista Maestra de Compras',
  desc: 'Tu taller pro en 1 visita',
  value: '$35.000'
}, {
  id: 2,
  title: 'Scripts WhatsApp + IG',
  desc: '20 mensajes que cierran trabajos',
  value: '$28.000'
}, {
  id: 3,
  title: 'Checklist Medición Perfecta',
  desc: 'El anti-error más caro del oficio',
  value: '$25.000'
}, {
  id: 4,
  title: 'Pack Croquis Listos',
  desc: 'Ventanas, puertas y paños fijos',
  value: '$32.000'
}, {
  id: 5,
  title: 'Guía Control de Calidad',
  desc: 'Entregá sin reclamos',
  value: '$22.000'
}, {
  id: 6,
  title: 'Tracker Costos y Ganancia',
  desc: 'Sabé si realmente ganás',
  value: '$28.000'
}];
export function BonosSection() {
  return <section className="py-10 bg-matte text-white" data-id="element-11">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-12">
        <div className="text-center mb-8" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-14">
            LOS 6 BONOS — GRATIS
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto" data-id="element-15"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-16">
          {bonos.map((bono, index) => <motion.div key={bono.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-darkgray border border-silver/20 p-5 relative group hover:border-gold transition-colors" data-id="element-17">
              <div className="absolute -top-3 -right-3 bg-gold text-matte w-10 h-10 flex items-center justify-center rounded-full font-black text-sm shadow-lg" data-id="element-18">
                #{bono.id}
              </div>
              <Gift className="w-6 h-6 text-gold mb-3" data-id="element-19" />
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-20">
                {bono.title}
              </h3>
              <p className="text-gray-400 text-sm mb-4" data-id="element-21">{bono.desc}</p>
              <div className="flex items-center justify-between border-t border-silver/10 pt-3" data-id="element-22">
                <span className="text-gray-500 line-through text-xs" data-id="element-23">
                  {bono.value}
                </span>
                <span className="text-gold font-black" data-id="element-24">✓ GRATIS</span>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-steel border-2 border-gold p-6 text-center max-w-2xl mx-auto" data-id="element-25">
          <h3 className="text-xl md:text-3xl font-black" data-id="element-26">
            Valor total:{' '}
            <span className="line-through text-silver/60" data-id="element-27">$170.000</span>{' '}
            <span className="text-gold ml-2" data-id="element-28">→ GRATIS</span>
          </h3>
        </div>
      </div>
    </section>;
}